import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Paragraph, Button, Grid } from '@increasecard/typed-components';
import { Header } from '../../components/common/Header';
import { GoBackButton } from '../../components/common/GoBackButton';
import { ScreenSeparator } from '../../components/common/ScreenSeparator';
import { PaymentLinkForm } from './PaymentLinkForm';
import { PaymentLink } from '../../types/PaymentLink';

export function PaymentLinkCreateScreen(): JSX.Element {
  const history = useHistory();
  const [createdLink, setCreatedLink] = useState<PaymentLink | null>(null);

  const handleSuccess = (link: PaymentLink) => {
    setCreatedLink(link);
  };

  const goToList = () => {
    history.push('/invoices/payment-links');
  };

  if (createdLink) {
    return (
      <>
        <GoBackButton onClick={goToList} />
        <Header title="Link de pago creado" />
        <ScreenSeparator />
        <Grid rowGap={2}>
          <Paragraph>
            El link de pago <strong>{createdLink.name}</strong> se creó
            correctamente.
          </Paragraph>
          <Paragraph>
            Compartí este link con tus clientes para que puedan realizar el
            pago.
          </Paragraph>
          <div
            style={{
              padding: '1rem',
              background: 'var(--color-gray-grayLight)',
              borderRadius: '8px',
              wordBreak: 'break-all',
            }}
          >
            {createdLink.id}
          </div>
          <Button buttonType="primary" onClick={goToList}>
            Ir a lista de links
          </Button>
        </Grid>
      </>
    );
  }

  return (
    <>
      <GoBackButton onClick={goToList} />
      <Header
        title="Crear link de pago"
        description="Configurá el link de pago para compartir con tus clientes"
      />
      <ScreenSeparator />
      <PaymentLinkForm onSuccess={handleSuccess} onCancel={goToList} />
    </>
  );
}
